"use strict"

window.app = window.app || {}

window.app = (function(app, $) {

    NodeList.prototype.forEach = Array.prototype.forEach

    app.initCallbacks = []
    app.addInitCallback = function(fn) {
        app.initCallbacks.push(fn)
    }

    app.init = () => {
        app.initCallbacks.forEach(cb => cb(app))

        // MENU SLIDING
        initMenu(document.querySelectorAll("header nav.menu .menu-link"))
        
        // MOBILE MENU
        document.querySelector("header .menu-btn").addEventListener("click", e => {
            e.preventDefault()
            const menu = document.querySelector("header .menu")
            if(menu.classList.contains("active"))
                menu.classList.remove("active")
            else
                menu.classList.add("active")
        })

        // MAP
        let mapNode = document.getElementById('map')
        if(!!mapNode && !!google.maps) {
            let map = new google.maps.Map(mapNode, {
                    zoom: 10,
                    center: {lat: 48.891118, lng: 16.570190}
                })

            let marker_prumyslova = new google.maps.Marker({
                    position: {lat: 48.970681, lng: 16.520074},
                    title: 'Průmyslová 1503',
                    map
                }),
                marker_mikulov = new google.maps.Marker({
                    position: {lat: 48.800663, lng: 16.624969},
                    title: 'Gebauer a Griller Kabeltechnik',
                    map
                })

        }
    }
    
    /*
     * MENU SLIDING
     * */
    const easeInOutQuad = t => t<.5 ? 2*t*t : -1+(4-2*t)*t
    const getCoords = el => {
        let rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop
        return {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft
        }
    }
    
    const slideTo = (el, duration = 1000) => {
        let elCoords = getCoords(el),
            menuOffsetHeight = document.querySelector("header").offsetHeight,
            targetPos = elCoords.top - menuOffsetHeight

        if(!duration)
            document.documentElement.scrollTop = document.body.scrollTop = targetPos
        else {
            const
                startPos = window.pageYOffset,
                deltaPos = targetPos - startPos,
                startTime = new Date().getTime(),
                endTime = startTime + duration

            const anim = () => {
                const actualTime = new Date().getTime(),
                    timePos = endTime - actualTime,
                    animProgress = easeInOutQuad(1+(timePos/duration)*(-1)),
                    scrollTop = startPos + (animProgress * deltaPos)

                if(timePos < 0) {
                    document.documentElement.scrollTop = document.body.scrollTop = targetPos
                    return
                }

                document.documentElement.scrollTop = document.body.scrollTop = scrollTop
                requestAnimationFrame(anim)
            }
            anim()
        }
    }
    
    const initMenu = menuLinks => {
        Array.prototype.forEach.call(menuLinks, link => {
            const href = link.attributes.href.value,
                hashPos = href.indexOf("#")
            if(hashPos >= 0) {
                const targetEl = document.getElementById(href.substr(hashPos))
                if(targetEl) {
                    link.addEventListener("click", e => {
                        e.preventDefault()
                        slideTo(targetEl)
                    })
                }
            }
        })

        if(window.location.hash.substr(0, 1) === "#") {
            const targetEl = document.getElementById(window.location.hash)
            if(targetEl)
                slideTo(targetEl, 0)
        }
    }

    $(document).ready(function () {

        init_light_box();

        // // úprava volných pozic
        // (function() {
        //     // na stránce musí být <script type="text/javascript" src="//widget.lmcg2.com/ver1/widget.php?id=35362ca20b5ef0c167edbcffbeeeaca46b6d6a96&type=fragment"></script>
        //     let $ul = $('ul#g2l-l');
        //     if ($ul.length > 0) {
        //         $('.g2-list').removeClass();
        //         $('.positions link').remove();
        //         $ul.attr('id', 'imported-positions')
        //         $ul.addClass('positions-list');
        //         //$('.g2-footer').css({'text-align': 'right', 'margin-top': '10px'});
        //         $('.g2-footer').remove();
        //         $('li > a', $ul).each(function () {
        //             let $link = $(this);
        //             $link.attr('target', '_blank');
        //             let $link2 = $link.clone();
        //             $link.addClass('left');
        //             $link2.addClass('right').addClass('btn').text('Více info');
        //             $link2.insertAfter($link);
        //         });
        //     }
        // }());

        $(document.body).on("click", "a.ajax", function (event) {
            event.preventDefault();
            $.get(this.href);
            $(".ajax-spinner").show();
        });

        $(document.body).on('submit', 'form.ajax', function() {
            $(this).ajaxSubmit();
            return false;
        });

        // odeslání formuláře webtextu ajaxem - formuláři je potřeba nastavit třídu wtajax
        $('form.wtxajax').on('submit', function () {
            var $that = $(this);
            if ($that.data('htmlid') !== undefined) { // z formuláře vyrušit onsubmit a doplnit data-htmlid
                if (!webx_validate_form($that.data('htmlid'))) {
                    return false;
                }
            }
            $that.prevAll('.report').remove(); // odstranit předchozích reportů

            $(this).ajaxSubmit(function(payload){
                jQuery(".ajax-spinner").hide();

                if (payload.report) {

                    // přidání reportu
                    var $rep = $('<p>');
                    $rep.addClass('report');
                    $rep.addClass(payload.report.type);
                    $rep.html(payload.report.txt);
                    $that.before($rep);

                    if (payload.report.clean_form) { // vyprázdnit formulář
                        $('input[type=text],input[type=password],textarea', $that).val('');
                        $('input[type=checkbox]', $that).prop('checked', false);
                    }
                    if (payload.report.remove_form) { // odstraň formulář
                        $that.remove();
                    }

                }

            });
            return false;
        });

        // zavírání/otvírání bloků
        $('.titlebox.open>.titlebox-content').slideDown();
        $('.titlebox>h2.titlebox-title').click(function(ev){
            var $parent = $(this).parent();
            var was_opened = $parent.hasClass('open');
            $('.titlebox.open').each(function(){
                var $el = $(this);
                $('.titlebox-content', $el).slideUp();
                $el.removeClass('open');
            });
            if (!was_opened) {
                $parent.addClass('open');
                $('.titlebox-content', $parent).slideDown();
            }
            ev.preventDefault();
            return false;
        });

    });




    app.tag = (name, attrs = {}) => {
        let el = document.createElement(name.toString())
        !!attrs && Object.keys(attrs).forEach(key => el.setAttribute(key, attrs[key]))
        return el
    }

    return app
})(window.app, jQuery)